import * as React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

export const TileLarge = (props) => (
    <SvgIcon {...props}>
        <path d="M6.9,23.4H0.7c-0.4,0-0.7-0.3-0.7-0.7v-22C0,0.3,0.3,0,0.7,0h6.2c0.4,0,0.7,0.3,0.7,0.7v22C7.6,23.1,7.3,23.4,6.9,23.4z" />
        <path d="M15.9,23.4H9.7c-0.4,0-0.7-0.3-0.7-0.7v-22C9,0.3,9.3,0,9.7,0h6.2c0.4,0,0.7,0.3,0.7,0.7v22C16.6,23.1,16.3,23.4,15.9,23.4z" />
    </SvgIcon>
);

export default TileLarge;
